export interface OrderForm {
  submission_key: string
  order_date: string | null
  participant_name: string
  member_number: string
  center_id: string | null
  product_id: string | null
}

export interface Order {
  id: string
  submission_key: string
  submitted_at: string
  submitted_by_oid: string
  submitted_by_name: string
  submitted_by_email: string | null
  order_date: string
  participant_name: string
  member_number: string
  center_id: string
  center_name: string
  product_id: string
  product_name: string
  product_style: string
  email_subject: string
  email_body: string
  email_sent_at: string | null
  email_attempts: number
}

export interface OrderSummary {
  id: string
  submitted_at: string
  order_date: string
  participant_name: string
  member_number: string
  center_name: string
  submitted_by_name: string
  product_name: string
  email_sent: boolean
}

export interface Submitter { oid: string; name: string; email: string | null }

/** The sweep stops retrying an order's email after this many send attempts. */
export const MAX_EMAIL_ATTEMPTS = 24
